/* reformly-pick-a-card.js — flip-to-reveal prize game.
   Cards are shuffled per visit; each pick reveals the next prize from a shuffled
   prize list, so every shopper sees all prizes in a different order. */
(function () {
  var roots = document.querySelectorAll('[data-rpc]');
  if (!roots.length) return;

  function shuffle(a) {
    for (var i = a.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var t = a[i]; a[i] = a[j]; a[j] = t;
    }
    return a;
  }

  roots.forEach(function (root) {
    var target = Math.max(1, parseInt(root.getAttribute('data-rpc-picks'), 10) || 4);

    // ── PostHog ──────────────────────────────────────────────────────────────
    // Same shape as reformly-july4-hero.js: a reformly_pageset super-property
    // plus a per-page event prefix, so this page is separable in reports.
    //
    // Analytics must never affect the game: every call is queued, wrapped in
    // try/catch, and fire-and-forget. Two failure modes this guards against —
    //   1. posthog.js loads async and may not exist yet, so events queue and
    //      flush once it appears (polled briefly, then given up on).
    //   2. capture() is an async XHR the browser kills on unload, so anything
    //      fired while navigating away uses sendBeacon instead.
    var pageTemplate = root.getAttribute('data-rpc-template') || '';
    var phQueue = [];
    var phReady = false;
    var phUnloading = false;

    function phFlush() {
      if (!(window.posthog && typeof window.posthog.capture === 'function')) return false;
      if (!phReady) {
        phReady = true;
        try {
          if (typeof window.posthog.register === 'function') {
            window.posthog.register({ reformly_pageset: 'pick-a-card' });
          }
        } catch (e) { /* never block the game on analytics */ }
      }
      while (phQueue.length) {
        var q = phQueue.shift();
        var opts = phUnloading ? { transport: 'sendBeacon' } : q[2];
        try {
          window.posthog.capture(q[0], q[1], opts);
        } catch (e) {
          // `transport` isn't supported on every posthog-js version, and the
          // throw would otherwise vanish into this catch — retry without it.
          try { window.posthog.capture(q[0], q[1]); } catch (e2) { /* drop it */ }
        }
      }
      return true;
    }

    // Nothing here is awaited, and the flush is kept off the critical path:
    // capture() does synchronous work of its own, so running it inside a click
    // or flip handler can cost a frame mid-animation. Queue, return, send later.
    var phScheduled = false;
    function phSchedule() {
      if (phScheduled) return;
      phScheduled = true;
      var run = function () { phScheduled = false; phFlush(); };
      if (window.requestIdleCallback) window.requestIdleCallback(run, { timeout: 2000 });
      else setTimeout(run, 0);
    }

    function ph(event, props, opts) {
      var p = props || {};
      p.page_template = pageTemplate;
      p.picks_required = target;
      phQueue.push(['rpc_' + event, p, opts]);
      // sendBeacon means we're navigating away — must hand off before unload.
      // It's non-blocking by spec: the browser takes ownership and returns at once.
      if (opts && opts.transport === 'sendBeacon') phFlush();
      else phSchedule();
    }

    if (!phFlush()) {
      var phTries = 0;
      var phPoll = setInterval(function () {
        if (phFlush() || ++phTries > 40) clearInterval(phPoll); // give up after ~10s
      }, 250);
    }

    var startedAt = Date.now();
    var useConfetti = root.getAttribute('data-rpc-confetti') !== 'false';
    var ctaLabel = root.getAttribute('data-rpc-cta') || 'Continue';
    var doneText = root.getAttribute('data-rpc-done-text') || 'Congratulations';
    var idleText = root.getAttribute('data-rpc-idle-text') || '';

    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-rpc-card]'));
    var cta = root.querySelector('[data-rpc-cta-el]');
    var counter = root.querySelector('[data-rpc-counter]');
    var subhead = root.querySelector('[data-rpc-subhead]');
    var canvas = root.querySelector('canvas');

    var prizes = [];
    try { prizes = JSON.parse(root.querySelector('[data-rpc-prizes]').textContent) || []; } catch (e) { prizes = []; }
    if (!prizes.length || !cards.length) return;
    shuffle(prizes);

    // Warm the prize art now. Otherwise the first reveal of each prize fetches
    // and decodes a CDN image mid-flip, which stutters the 560ms rotate.
    // .decode() matters as much as the download: without it the bitmap is only
    // decoded when it first paints — which is mid-flip. This forces it up front.
    prizes.forEach(function (p) {
      if (!p.img) return;
      var pre = new Image();
      pre.decoding = 'async';
      pre.src = p.img;
      if (pre.decode) pre.decode().catch(function () { /* cache miss is fine */ });
    });

    // stagger the sway so the grid doesn't pulse in unison
    shuffle(cards.map(function (_, i) { return i; })).forEach(function (slot, i) {
      cards[i].style.animationDelay = (slot * 0.32).toFixed(2) + 's';
    });

    var picks = 0;

    function sync() {
      var done = picks >= target;
      root.classList.toggle('rpc--done', done);
      if (counter) counter.textContent = picks + '/' + target;
      if (subhead) subhead.textContent = done ? doneText : idleText;
      if (cta) {
        var remaining = target - picks;
        cta.textContent = done ? ctaLabel : 'Flip ' + remaining + (remaining === 1 ? ' more card' : ' more cards');
        if (cta.tagName === 'BUTTON') cta.disabled = !done;
        else if (done) cta.removeAttribute('aria-disabled');
        else cta.setAttribute('aria-disabled', 'true');
      }
    }

    function flip(card) {
      if (card.classList.contains('is-revealed') || picks >= target) return;
      var prize = prizes[picks % prizes.length];
      var img = card.querySelector('[data-rpc-prize-img]');
      var name = card.querySelector('[data-rpc-prize-name]');
      if (img && prize.img) img.style.backgroundImage = 'url("' + prize.img + '")';
      if (name) name.textContent = prize.name || '';
      card.classList.add('is-revealed');
      card.setAttribute('aria-label', prize.name || 'Prize revealed');
      picks++;
      sync();
      ph('card_flip', { pick: picks, prize: prize.name || '', remaining: target - picks });
      if (picks >= target) {
        ph('game_complete', {
          prizes: prizes.slice(0, target).map(function (x) { return x.name; }),
          seconds_to_complete: Math.round((Date.now() - startedAt) / 1000)
        });
        if (useConfetti) setTimeout(burst, 400);
      }
    }

    if (cta) {
      // Fired on pointerdown, not click: by the time `click` runs the browser is
      // already navigating and kills the in-flight request. pointerdown happens
      // a beat earlier (mouse/finger down), so the event gets away cleanly —
      // without delaying navigation at all. `sent` keeps it to one per session,
      // and pagehide is the backstop if the pointer path never fires.
      var ctaSent = false;
      var sendCtaClick = function () {
        if (ctaSent || picks < target) return;
        ctaSent = true;
        ph('cta_click', { href: cta.getAttribute('href') || '' });
        phFlush(); // send now — an idle callback may not run before we navigate
      };
      cta.addEventListener('pointerdown', sendCtaClick);
      cta.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') sendCtaClick();
      });

      // <a> ignores aria-disabled, so block navigation until every pick is made
      cta.addEventListener('click', function (e) {
        if (picks < target) { e.preventDefault(); e.stopPropagation(); return; }
        sendCtaClick(); // no-op if pointerdown already sent it
        phFlush();      // hand off anything still queued before we leave
      });
    }

    cards.forEach(function (card) {
      card.addEventListener('click', function () { flip(card); });
      card.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); flip(card); }
      });
    });

    var raf = null;
    var gravity = 0.26;
    function burst() {
      if (!canvas) return;
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      var dpr = window.devicePixelRatio || 1;
      var w = canvas.clientWidth, h = canvas.clientHeight;
      canvas.width = w * dpr; canvas.height = h * dpr;
      var ctx = canvas.getContext('2d');
      ctx.scale(dpr, dpr);
      var colors = ['#6B1E7E', '#222222', '#FFFFFF', '#F5F5F5', '#A175FF'];
      // The mobile mock tunes the burst down — fewer, smaller, slower particles
      // so it doesn't overwhelm a phone screen. Same 560px breakpoint as the CSS.
      var small = w <= 560;
      var count = small ? 110 : 150;
      var sizes = small ? [5, 6, 8] : [6, 8, 10];
      var spreadX = small ? 0.6 : 0.5;
      var originY = small ? 0.4 : 0.42;
      var jitterY = small ? 40 : 60;
      var velX = small ? 8 : 10;
      var velUp = small ? 8 : 10;
      var velBase = small ? 5 : 6;
      gravity = small ? 0.24 : 0.26;
      var parts = [];
      for (var i = 0; i < count; i++) {
        parts.push({
          x: w / 2 + (Math.random() - 0.5) * w * spreadX,
          y: h * originY + (Math.random() - 0.5) * jitterY,
          vx: (Math.random() - 0.5) * velX,
          vy: -velBase - Math.random() * velUp,
          s: sizes[(Math.random() * 3) | 0],
          c: colors[(Math.random() * colors.length) | 0]
        });
      }
      var start = performance.now(), life = 2600, fade = 900;
      function tick(now) {
        var t = now - start;
        ctx.clearRect(0, 0, w, h);
        ctx.globalAlpha = t > life - fade ? Math.max(0, (life - t) / fade) : 1;
        for (var k = 0; k < parts.length; k++) {
          var p = parts[k];
          p.vy += gravity; p.x += p.vx; p.y += p.vy;
          ctx.fillStyle = p.c;
          ctx.fillRect(p.x, p.y, p.s, p.s);
        }
        ctx.globalAlpha = 1;
        if (t < life) raf = requestAnimationFrame(tick);
        else ctx.clearRect(0, 0, w, h);
      }
      raf = requestAnimationFrame(tick);
    }

    window.addEventListener('pagehide', function () {
      if (raf) cancelAnimationFrame(raf);
      phUnloading = true;
      phFlush();
    });
    sync();
    ph('page_view', { url: window.location.href, referrer: document.referrer, cards: cards.length });
  });
})();
